import { IAppState } from '../../redux';

export function selectIsServicesEnabled(state: IAppState): boolean {
  return state.publishTerms.isServicesEnabled;
}
